const routes = [
  {
    path: "/videoMonitoringOld", // 主页面
    name: "videoMonitor",
    redirect: "/videoMonitoring/index",
    component: () => import("./view/Home"),
    meta: {
      requireAuth: false,
      routerAlive: true
    },
    children: [
      {
        path: "index", // 实时浏览
        name: "videoMonitoringIndex",
        component: () => import("./view/index"),
        meta: {
          module:"videoMonitoring",
          requireAuth: false,
          routerAlive: true
        }
      },
     
    ]
  }
];

export default routes;
